__turbopack_context__.v({
  "root": "FeedFooter-module__fHsgMG__root",
  "viewAll": "FeedFooter-module__fHsgMG__viewAll",
});
